<template>
    <div class='standard-table'>
        <a-table
            bordered
            size="small"
            :columns="columns"
            :rowKey="rowKey"
            :data-source="dataSource"
            :pagination="pagination"
            :scroll="scroll"
            :row-selection="rowSelection"
            @change="handleTableChange">
            
            <template slot-scope="text, record, index" :slot="slot" v-for="slot in Object.keys($scopedSlots).filter(key => key !== 'expandedRowRender') ">
                <slot :name="slot" v-bind="{text, record, index}"></slot>
            </template>

            <template :slot="slot" v-for="slot in Object.keys($slots)">
                <slot :name="slot"></slot>
            </template>
            
            <template slot-scope="record, index, indent, expanded" :slot="$scopedSlots.expandedRowRender ? 'expandedRowRender' : ''">
                <slot v-bind="{record, index, indent, expanded}" :name="$scopedSlots.expandedRowRender ? 'expandedRowRender' : ''"></slot>
            </template>
        </a-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        };
    },
    props: {
        dataSource: Array,
        columns: Array,
        rowKey: {
            type: [String, Function],
            default: 'id'
        },
        scroll: {
            type: [Object, Function],
            default: ()=>{ y: 'calc(100vh - 330px)' }
        },
        rowSelection: {
            type: Object,
            default: null
        },
        pagination: Object
    },
    created() {

    },
    methods: {
        handleTableChange (pagination) {
            this.$emit('handleTableChange', pagination)
        }
    },
}
</script>

<style lang='scss' scoped>

.standard-table{
  ::v-deep .ant-table-header, 
  ::v-deep .ant-table-thead {
    background: #F6F8FA
  }
  ::v-deep .ant-table-tbody .ant-table-row:nth-child(2n) {
    background: #FDFDFD;
  }
  ::v-deep .ant-table-body {
      margin: 0 !important;
      overflow-y: auto !important;
  }
    ::v-deep(.ant-table-header) {
     overflow-y: hidden !important;
     padding-right: 9px;
   }
}
</style>